var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button",
    {
      staticClass: "back-button",
      on: {
        click: function ($event) {
          return _vm.goBack(_vm.returnUrl)
        },
      },
    },
    [
      _c("i", { staticClass: "fa-solid fa-arrow-left" }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("common.bck")))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }